const withoutNumbers = value => value.indexOf(`0`) !== -1 ? value.split('0')[ 0 ] : value;
export default withoutNumbers;